module.exports = __webpack_public_path__ + "static/media/GothamBold.722c5f89.otf";